import React, { useEffect, useState } from "react";
import CheckBoxInput from "@components/input/CheckBoxInput";
import { BrandDropdownInput } from "@pages/register/_components/index";
import styled from "@emotion/styled";

import { useFormContext } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import LabelWithInput from "@components/input/LabelWithInput";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  // zIndex: "1003",
  ".label": {
    fontSize: "1.6rem",
    lineHeight: "1.6rem",
    fontWeight: theme.fontWeight.medium,
  },

  ".desc": {
    fontSize: "1.2rem",
    lineHeight: "1.2rem",
    color: theme.color.gray,
  },
}));

const InputContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
});

const NoBrandBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.6rem",

  ".error": {
    color: theme.color.orange,
    fontSize: "1.2rem",
    lineHeight: "1.2rem",
  },
}));

const BrandNameInput = styled.input(({ theme }) => ({
  width: "100%",
  padding: "1.2rem 1.6rem",
  fontSize: "1.4rem",
  lineHeight: "1.4rem",
  border: `1px solid ${theme.color.light_gray}`,
  outline: "none",
  "&:focus": {
    borderColor: theme.color.black,
  },
  "&::placeholder": {
    color: theme.color.gray,
  },
}));

const ErrorMessage = styled.div(({ theme }) => ({
  color: theme.color.orange,
  fontSize: "1.2rem",
  lineHeight: "1.8rem",
}));

const BrandCheckList = ({ brandRef }: { brandRef?: any }) => {
  const {
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useFormContext();

  const { getBrandList } = useApiRequest();
  const brandId = watch("brand_id");

  useEffect(() => {
    if (brandId) {
      trigger("brand_id");
    }
  }, [brandId, trigger]);

  // 브랜드 ID에 따라 초기 selectedKey 설정
  const [selectedKey, setSelectedKey] = useState(() => {
    if (!brandId) return null;
    if (brandId === -1) return -1; // 브랜드 없음
    if (brandId === -2) return -2; // 노라벨
    return brandId; // 그 외의 경우는 실제 브랜드 ID
  });

  const { data: brandList } = useQuery({
    queryKey: ["brandList"],
    queryFn: getBrandList,
  });

  const handleInputClick = (key: number) => {
    setSelectedKey(key);
    setValue("brand_id", key);
  };

  return (
    <Container ref={brandRef}>
      <LabelWithInput label="브랜드" required />
      <span className="desc">{"아래 세가지 옵션 중 하나를 선택해주세요."}</span>

      <InputContainer>
        <BrandDropdownInput
          options={brandList}
          name="brand_id"
          setSelectedKey={setSelectedKey}
        />

        <NoBrandBox>
          <CheckBoxInput
            label="찾는 브랜드 없음"
            checked={selectedKey === -1}
            onClick={() => handleInputClick(-1)}
          />
          {selectedKey === -1 && (
            <BrandNameInput
              type="text"
              placeholder="브랜드명을 입력해주세요"
              value={watch("brand_name") || ""}
              onChange={(e) => setValue("brand_name", e.target.value)}
            />
          )}
        </NoBrandBox>
        <CheckBoxInput
          label="노라벨 (라벨이 없는 상품)"
          checked={selectedKey === -2}
          onClick={() => handleInputClick(-2)}
        />
        {errors?.brand_id && (
          <ErrorMessage>{errors?.brand_id?.message?.toString()}</ErrorMessage>
        )}
      </InputContainer>
    </Container>
  );
};

export default BrandCheckList;
